var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Vrstva_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "24px",
    height: "24px",
    viewBox: "8 8 24 24",
    enableBackground: "new 8 8 24 24",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico__x2F__zkusenosti"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector__x28_Stroke_x29_",
    d: "M8,16.091c0-4.017,3.256-7.289,7.268-7.289c1.778,0,3.442,0.645,4.732,1.755 c1.29-1.111,2.954-1.755,4.732-1.755c4.012,0,7.268,3.272,7.268,7.289c0,1.994-0.797,3.862-2.213,5.234L20,31.198l-9.967-10.052 l-0.008-0.009C8.719,19.772,8,17.977,8,16.091z M15.268,11.374c-2.584,0-4.697,2.112-4.697,4.717c0,1.221,0.461,2.376,1.305,3.262 L20,27.548l7.98-8.053l0.011-0.009c0.921-0.89,1.438-2.095,1.438-3.395c0-2.605-2.112-4.717-4.696-4.717 c-1.48,0-2.836,0.689-3.714,1.829L20,14.524l-1.019-1.322C18.104,12.063,16.748,11.374,15.268,11.374z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector__x28_Stroke_x29__x5F_2",
    d: "M26.96,15.597l-7,7.494l-4.564-4.667l1.838-1.798l2.683,2.743 l5.164-5.528L26.96,15.597z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.8f7d33788c4e0e7fd3d7faca49fa3463.svg";
export { ForwardRef as ReactComponent };